import { PopularDestinationsCard } from './PopularDestinationsCard';

type Destination = {
    image: string;
    label: string;
    alt: string;
    href: string;
};

type PopularDestinationsProps = {
    id: string;
    heading: string;
    destinations: Destination[];
};

export const PopularDestinations = ({ id, heading, destinations }: PopularDestinationsProps) =>
    destinations.length > 1 ? (
        <section className="mb-32" aria-labelledby={id}>
            <h3 id={id} className="px-16 mb-16">
                {heading}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-16 px-16">
                {destinations.map((dest) => (
                    <PopularDestinationsCard
                        key={dest.image}
                        id={`${id}-${dest.image}`}
                        src={dest.image}
                        alt={dest.alt}
                        label={dest.label}
                        href={dest.href}
                    />
                ))}
            </div>
        </section>
    ) : null;
